import React from 'react';
import ClickHandlerWithLoaderContainer from '../../../../Common/ClickHandlerWithLoader/ClickHandlerWithLoaderContainer';
import SettingsRow from '../../../Common/SettingsRow/SettingsRow';
import GoogleSearchConsoleIcon from '../../../../Common/GoogleSearchConsoleIcon';
import { getI18N } from 'qs-services/i18N';

export default ({ onSelected, settingComponentId, classForContainer }) => {
  const { t } = getI18N();

  return (
    <ClickHandlerWithLoaderContainer
      clickProps={{
        clickHandler: onSelected,
        clickParams: settingComponentId
      }}
      type="button"
      classForContainer={classForContainer}
    >
      <SettingsRow Icon={GoogleSearchConsoleIcon} title={t('google_search_console')}>
        <span>{t('google_search_settings')}</span>
      </SettingsRow>
    </ClickHandlerWithLoaderContainer>
  );
};
